var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "objective-landing-page" }, [
    _c("div", { staticClass: "objective-landing-page__content" }, [
      _c(
        "div",
        { staticClass: "objective-landing-page__content--title" },
        [
          _c("h1", { staticClass: "typographies-display-brand-large" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$l10n.__("Maximisez vos objectifs commerciaux")) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "ImgSvg",
            {
              staticClass: "underline",
              attrs: { width: "193px", height: "9px" }
            },
            [_c("Underline")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "objective-landing-page__content--informations" },
        [
          _c("p", {
            staticClass: "typographies-paragraph-large-regular",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t.__(
                  "objectives.landing.ObjectiveLandingPage.informations_line_1",
                  {
                    startStrong:
                      "<span class='typographies-paragraph-large-semibold'>",
                    endStrong: "</span>"
                  }
                )
              )
            }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "typographies-paragraph-large-regular",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t.__(
                  "objectives.landing.ObjectiveLandingPage.informations_line_2",
                  {
                    startStrong:
                      "<span class='typographies-paragraph-large-semibold'>",
                    endStrong: "</span>"
                  }
                )
              )
            }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "typographies-paragraph-large-regular",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t.__(
                  "objectives.landing.ObjectiveLandingPage.informations_line_3",
                  {
                    startStrong:
                      "<span class='typographies-paragraph-large-semibold'>",
                    endStrong: "</span>"
                  }
                )
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "objective-landing-page__content--buttons" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.contact_sales"),
              size: "large"
            },
            on: { click: _vm.openIntercom }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "objective-landing-page__illustration" }, [
      _c("img", {
        attrs: {
          src:
            "/ressources/logged/img/illustrations/objective-widget-illustration.png"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }